// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"_1MLi1opVttdFDkhohQwQEe"};